/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { TicketTextFontPath } from './TicketTextFontPath';
import { TicketContainer, TICKET_CHANGE_EVENTS } from '../tickets/TicketContainer';
import { TICKET_LOCATION_NAME_SETTINGS } from './TICKET_TEXT_SETTINGS';
import { FancyContainer } from '@appCanvasCommon/graphics/FancyContainer';
import { Side } from '@touchplan/common';
import { CanvasAngularLand } from 'src/app/app-data/interfaces/canvas-angular-land';
import { Ticket } from '@touchplan/common';
import { IFontOptions } from '@appCanvasCommon/fontpath/fontpath.interfaces';
import { WORD_WRAP_MODE } from '@appCanvasCommon/fontpath/WordWrapper';
import { setTicketWidthHelper } from 'src/app/utils/ticket-utils';
import { EventMode } from '@appCanvasCommon/events/event-mode.enum';

export class TicketLocationNameFontPath extends TicketTextFontPath {
	// TODO: Apply the mask globally on the world;
	public maskContainer: FancyContainer = new FancyContainer();

	constructor(
		fontFamily: string,
		canvasAngularLand: CanvasAngularLand,
		ticketContainer: TicketContainer,
		text: string = '',
		fontOptions: IFontOptions = { fontSize: 22, wordWrapOptions: { mode: WORD_WRAP_MODE.GREEDY } }
	) {
		super(fontFamily, canvasAngularLand, ticketContainer, text, fontOptions);

		this.maskContainer.addChild(this);

		this.clipToMaskArea = true;

		ticketContainer.on(TICKET_CHANGE_EVENTS.CHANGED, this.onChanged);

		this.onChanged(ticketContainer, null);
		this.eventMode = EventMode.None;
	}

	public onChanged = (ticketContainer: any, old: any) => {
		const data: Ticket = ticketContainer.getData();
		const layout = ticketContainer.getLayout();

		if (!data.view.location) {
			this.renderable = false;
		} else {
			this.renderable = true;
			this.tint = this.ticket.locationTextColor;

			const pullSuffix = data.view.side === Side.PULL ? '_PULL' : '';

			this.x = TICKET_LOCATION_NAME_SETTINGS['LEFT_MARGIN' + pullSuffix] || 0;
			this.y = TICKET_LOCATION_NAME_SETTINGS['TOP_MARGIN' + pullSuffix] || 0;

			const paddingRight: number = TICKET_LOCATION_NAME_SETTINGS['RIGHT_MARGIN' + pullSuffix] || 0;
			const height: number = TICKET_LOCATION_NAME_SETTINGS['DRAWING_AREA_HEIGHT' + pullSuffix] || 0;

			const width = setTicketWidthHelper(data, layout, this.canvasAngularLand.wideTicketSize$.getValue());
			this.wordWrapWidth = width - paddingRight - this.x;

			this.maskArea.x = this.x;
			this.maskArea.y = this.y;
			this.maskArea.width = this.wordWrapWidth;
			this.maskArea.height = height;

			this.setText(data.view.location?.view.name);
			if (data.view.side === Side.PULL) {
				this.fontSize = 32;
			} else {
				this.fontSize = 18;
			}
			this.calculateText();
		}
	};

	public override destroy(options?): void {
		this.ticket.off(TICKET_CHANGE_EVENTS.CHANGED, this.onChanged);
		this.maskContainer.destroy(options);

		this.maskContainer = null;
		super.destroy(options);
	}
}
